<template>
  <section v-if="$role.restricAccess($route.name, 'view')">
    <breadcrumb-template
      :headtitle="$route.meta.title"
      :breadcrumbcurrent="$route.meta.title"
    ></breadcrumb-template>
    <v-card class="card-outline force-remove-box">
      <v-card-text class="force-custom-bg">
        <v-container fluid>
            
              
          <v-row dense class="d-flex justify-end mt-n2">
            <!-- <v-col cols="12" lg="2" class="span-label">
              <span>Draw</span>
              <v-select class="regular-field" dense clearable :items="drawlist" item-value="id" item-text="name" label="Draw" v-model="filter.groupdraw" multiple>
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0" small>
                    <span>{{ item.name }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption">(+{{ filter.groupdraw.length - 1 }})</span>
                </template>
              </v-select>
            </v-col> -->

            <v-col cols="12" lg="2" class="span-label">
              <span>Date from:</span>
              <v-text-field clearable dense hide-details class="regular-field" v-model="filter.filterDateFrom" label="Date from" type="date"></v-text-field>
            </v-col>

            <v-col cols="12" lg="2" class="span-label">
              <span>Date to:</span>
              <v-text-field clearable dense hide-details class="regular-field" v-model="filter.filterDateTo" label="Date to" type="date"></v-text-field>
            </v-col>

            <v-col cols="12" lg="2" class="mt-7" style="padding-top:5px;">
              <v-btn color="green_button" class="float-right btn-block" @click="searchit()">Search</v-btn>
            </v-col>

            <v-col cols="12" class="mt-2">
                 <div class="table-responsive container-fluid">
              <table class="table table-bordered"  style="color:white">
                <thead>
                  <tr class="text-center">
                    <td>Date</td>
                    <td>Total Net income</td> 
                    <td>Total SOP</td>
                    <td>Total System</td>
                    <td>Total Operator</td>
                    <td>Total Financer</td>
                    <td>Total Prize fund</td>
                  </tr>
                </thead>
                <tbody v-for="(list, index) in ldsharing" :key="list.id" >
                  <tr 
                  data-toggle="collapse" :data-target="'#demo'+index" class="accordion-toggle"
                  >
                    <td class="expand-button">
                      <button class="btn btn-default btn-sm"><v-icon>mdi-subdirectory-arrow-right</v-icon></button> {{list.date | setDate}}
                    </td>
                     <td>
                      <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar>
                      {{(list.totalnet2D) | toCoin}}
                    </td>
                    <td>
                      <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar>
                      {{(list.sop2D) | toCoin}}
                    </td>
                    <td>
                       <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar>
                      {{(list.system2D) | toCoin}}
                    </td>
                    <td>
                      <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar>
                      {{(list.operator2D) | toCoin}}
                    </td>
                    <td>
                      <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar>
                      {{(list.financer2D) | toCoin}}
                    </td>
                    <td>
                      <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar>
                      {{(list.prizefund) | toCoin}}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="8" class="hiddenRow" style="background:gray">
                      <div :id="'demo'+index" class="accordian-body collapse">
                        <div class="container-fluid mb-4">
                          <div class="card mt-4">
                            <div class="card-header" style="color:black;">
                              <h6><b>Draws summary</b></h6>
                            </div>
                            <div class="card-body">
                               <div class="table-responsive">
                                  <table class="table">
                                    <thead>
                                      <tr>
                                        <td>Draw</td>
                                        <td>Gross sales per draw</td>
                                        <td>Payouts</td>
                                        <td>Win shares</td>
                                        <td>Commissions</td>
                                        <td>Net income</td>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(items, index) in list.l2draws" :key="index">
                                        <td>
                                        {{items.name}}
                                        </td>
                                        <td>
                                         <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar>
                                          {{items.totalsales | toCoin}}
                                        </td>
                                        <td>
                                          <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar>
                                          {{items.totalpayout | toCoin}}
                                        </td>
                                        <td>
                                         <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar>
                                          {{items.totalwinshare | toCoin}}
                                        </td>
                                        <td>
                                          <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar>
                                          {{items.commission | toCoin}}
                                        </td>
                                        <td>
                                          <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar>
                                          {{items.netincome | toCoin}}
                                        </td>
                                      </tr>
                                    </tbody>
                                    <tfoot>
                                      <tr>
                                        <td>Total net income : 
                                          <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar>
                                          <b> {{list.totalnet2D | toCoin}}</b></td>
                                        <td>SOP : 
                                         <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar> <b> {{list.sop2D | toCoin}} </b></td>
                                        <td>System : 
                                         <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar>
                                          <b> {{list.system2D | toCoin}}</b></td>
                                        <td>Operator :
                                         <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar>
                                         <b> {{list.operator2D | toCoin}}</b></td>
                                        <td>Financer : 
                                         <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar>
                                          <b> {{list.financer2D | toCoin}}</b></td>
                                        <td>Prize fund : 
                                         <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar>
                                          <b> {{list.prizefund | toCoin}}</b></td>
                                      </tr>
                                    </tfoot>
                                  </table>
                                </div>
                            </div>
                          </div>

                         
                        </div>
                      </div>
                    </td>
                  </tr>
                  
                </tbody>
                <tfoot>
                  <tr>
                   <td class="text-center" colspan="2"> <b>Total:</b> </td>
                   <td > <b> <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar> {{sop | toCoin}}</b> </td>
                   <td> <b> <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar> {{system | toCoin}}</b> </td>
                   <td> <b> <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar> {{operator | toCoin}}</b> </td>
                   <td> <b> <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar> {{financer | toCoin}}</b> </td>
                   <td> <b> <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"/></v-avatar> {{prizefund | toCoin}}</b> </td>
                  </tr>
                  
                </tfoot>
              </table>
            </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

  </section>
</template>

<script>
export default {
  data() {
    return {
      filter: new this.$Form({
        groupdraw: [],
        filterDateFrom: this.$moment().format("YYYY-MM-DD"),
        filterDateTo: this.$moment().format("YYYY-MM-DD"),
      }),
      drawlist: [],
      prizefund: "",
      totalnetincome: "",
      sop: "",
      system: "",
      operator: "",
      financer: "",

      totalnetincomethreeD: "",
      sopthreeD: "",
      systemthreeD: "",
      operatorthreeD: "",
      financerthreeD: "",
      prizefundthreeD: "",

      ldsharing: [],
      threeDsharing: [],
      totalgrand: [],
    };
  },
  methods: {
     searchit() {
       this.$axios.post(this.$_CONFIG.api()+"/sharingdaterage",{filter:this.filter}).then(({ data }) => {
        this.ldsharing = data.data;
        this.prizefund = data.allprizefund;
        this.sop = data.allsop;
        this.system = data.allsystem;
        this.operator = data.alloperator;
        this.financer = data.allfinancer;
        this.prizefund = data.allprizefund;
       });
  },
  },
  async created() {
    await this.searchit();
  },
  mounted() {},
};
</script>
<style scoped></style>